import axios from 'axios'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const configStore = create(
    persist(
        (set, get) => ({
            config: null,
            checksum: null,
            hasHydrated: false,
            setConfig: (data) => set({ config: data }),
            setChecksum: (data) => set({ checksum: data }),
            getConfig: () => {
                const config = get().config
                return config ?? null
            },
            getChecksum: () => {
                const checksum = get().checksum
                return checksum ?? null
            },
            refreshConfig: (newData, checksum) => {
                if (newData === null || checksum === null) {
                    return
                }
                return set({
                    checksum: checksum,
                    config: newData,
                })
            },
            refreshConfigByApi: async () => {
                const response = await axios.get(`${process.env.NEXT_PUBLIC_BACKEND_URL}/api/config/unauth?checksum=${get().checksum}`, {
                    validateStatus: function (status) {
                        return status < 500;
                    },
                });
                if (response.status === 304 && response.data == "") {
                    return true;
                }

                if (response?.data?.config && typeof response.data.config == "string") {
                    console.log("aqui")
                    return set({
                        // checksum: response.data.checksum,
                        config: JSON.parse(response.data.config),
                    })
                }

                return set({
                    checksum: response.data.checksum,
                    config: response.data.config,
                })
            },
            setHasHydrated: () => set({ hasHydrated: true })
        }),
        {
            name: 'config-storage',
            onRehydrateStorage: () => (state) => {
                state?.setHasHydrated()
            },
        }
    )
)


export { configStore }
